import { atom } from "recoil";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export const parentCompaniesAtom = atom<any>({
  key: RecoilKeys.ParentCompanies,
  default: [],
});
